module.exports = __webpack_public_path__ + "assets/img/ic-stopwatch.36d71d4a.svg";